module.exports = __webpack_public_path__ + "62c73403d6d5e5e5c1b0bd21b1899785.svg";